"use strict";
/**
 * Copyright (c) 2020, Microsoft Corporation (MIT License).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkerPipeName = getWorkerPipeName;
function getWorkerPipeName(conoutPipeName) {
    return "".concat(conoutPipeName, "-worker");
}
//# sourceMappingURL=conout.js.map